import Vue from "vue";
import VuePaycard from "vue-paycard";

Vue.use(VuePaycard);
